'use client';
import useTranslation from '@repo/ui/src/context/Translation/useTranslation';
import { RecipeStepProps } from '@repo/ui/src/types';
import Loading from '@components/Loading';
import RecipeStep from './_RecipeStep';
import Markdown from '@repo/ui/src/components/Markdown';

interface Props {
  loading?: boolean;
  steps?: Array<RecipeStepProps>;
  unitOfMeasure: number;
  beforeYouGetStarted?: {
    title: string;
    summary: string;
  };
  _testID: string;
}

const RecipeSteps = ({ loading, steps, unitOfMeasure, beforeYouGetStarted, _testID }: Props) => {
  const { t } = useTranslation();

  if (loading) {
    return (
      <>
        <h4 className="tra-text-web-heading-4 text-left">{t('recipeContent.stepsLabel')}</h4>{' '}
        <Loading color="brand" />
      </>
    );
  }

  if (!steps?.length) return null;

  return (
    <>
      {beforeYouGetStarted && (
        <>
          <h4 className="tra-text-web-heading-4 text-left pt-10 md:pt-0 mb-8">
            {beforeYouGetStarted.title}
          </h4>
          <Markdown bodySize="large">{beforeYouGetStarted.summary}</Markdown>
          <hr className="my-8" />
        </>
      )}
      <h4 className="tra-text-web-heading-4 text-left pt-10 md:pt-0">
        {t('recipeContent.stepsLabel')}
      </h4>
      <ul className="list-none pl-0">
        {steps?.map((step, i) => (
          <li
            key={i}
            data-test-id={`${_testID}_recipe_step_${i + 1}`}
            className="list-none border-b last:border-b-0 border-transparent-light-300"
          >
            <RecipeStep step={step} unitOfMeasure={unitOfMeasure} index={i} />
          </li>
        ))}
      </ul>
    </>
  );
};
export default RecipeSteps;
